(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
// ------------------------------------
//
// Theme
//
// ------------------------------------

(function ($) {

	if (typeof window.TheChurchCo_Dashboard == 'undefined') window.TheChurchCo_Dashboard = {};

	TheChurchCo_Dashboard = {

		// ------------------------------------
		// Init
		// ------------------------------------

		init: function ($element) {

			TheChurchCo_Dashboard.dashboard();

			TheChurchCo_Dashboard.checkForForm();


		},

		// ------------------------------------
		// Main Dashboard
		// ------------------------------------

		dashboard: function () {

			// Add Main Dashboard Class
			$('html').addClass('thechurchco-admin-dashboard');

			// Remove Sidebar
			$('#adminmenuback, #adminmenuwrap, #wpadminbar').remove();

			// Remove Drag & Drop MetaBox
			TheChurchCo_Dashboard.removeDragDropMetaBox();

			// Promos
			TheChurchCo_Dashboard.promos();

			// Add Acive
			TheChurchCo_Dashboard.onAdminLoaded();

			$('.dashboard-ultimate .trigger').on('click', function (e) {
				$('.dashboard-ultimate .tile-list').slideToggle()
			})


		},
		removeDragDropMetaBox: function () {
			if (!$('.meta-box-sortables').length) return;
			$('.meta-box-sortables').sortable({ disabled: true });
			$('.postbox .hndle').css('cursor', 'pointer');
		},

		promos: function () {

			let $promo = $('.dashboard-promo');
			if ($promo.length <= 0) return;
			let pid = $promo.data('promoId')
			let seen = TheChurchCo_Dashboard.getCookie(`dashboard_promo_seen_${pid}`);
			if (!seen) $promo.addClass('-show');

			let $close = $('.dashboard-promo .promo-close').on('click', function (e) {
				e.preventDefault();
				TheChurchCo_Dashboard.setCookie(`dashboard_promo_seen_${pid}`, true, 365);
				$promo.removeClass('-show');
			})
		},

		checkForForm: function () {

			// TODO: Hit the endpoint to check for form submission.
			let $missingInfoButton = $('[data-missing-setup-form]');
			if ($missingInfoButton.length <= 0) return;

			// Make the Request.			
			var data = {};
			data.email = $missingInfoButton.attr('data-missing-setup-form');

			// Send Data
			$.ajax({
				url: 'https://thechurchco.com/api/onboarding/setupform',
				type: 'POST',
				data: data,
				success: function (data, textStatus, jqXHR) {
					if (data.status === 'missing') {
						$missingInfoButton.slideDown();
					} else {
						TheChurchCo_Dashboard.saveFoundForm(data.id);
					}
				},
				error: function (jqXHR, textStatus, errorThrown) {

				}

			});


		},

		saveFoundForm: function (post_id) {

			// Make the Request.			
			var data = {};
			data.submission_id = post_id;

			// Send Data
			$.ajax({
				url: '/api/onboarding/savefoundform',
				type: 'POST',
				data: data,
				success: function (data, textStatus, jqXHR) {

				},
				error: function (jqXHR, textStatus, errorThrown) {

				}

			});
		},

		onAdminLoaded: function () {

			$('.wp-admin').addClass('-loaded');
			$('#login').addClass('-loaded');

		},
		// ------------------------------------
		// Set Cookie
		// ------------------------------------

		setCookie: function (c_name, value, exdays) {
			var exdate = new Date();
			exdate.setDate(exdate.getDate() + exdays);
			var c_value = escape(value) + ((exdays == null) ? "" : "; expires=" + exdate.toUTCString());
			document.cookie = c_name + "=" + c_value;
		},

		// ------------------------------------
		// Get Cookie
		// ------------------------------------

		getCookie: function (c_name) {
			var i, x, y, ARRcookies = document.cookie.split(";");
			for (i = 0; i < ARRcookies.length; i++) {
				x = ARRcookies[i].substr(0, ARRcookies[i].indexOf("="));
				y = ARRcookies[i].substr(ARRcookies[i].indexOf("=") + 1);
				x = x.replace(/^\s+|\s+$/g, "");
				if (x == c_name) {
					return unescape(y);
				}
			}
		}

	};

	module.exports = TheChurchCo_Dashboard;

})(jQuery);

}).call(this,require("rH1JPG"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/modules/dashboard.js","/modules")